module.exports = __webpack_public_path__ + "static/media/logo_icon.f3ac8c9f.jpg";